import gql from 'graphql-tag'

/* Función para obtener las afiliaciones de un usuario de tipo afiliado */
const FETCH_USER_AFFILIATIONS = gql`
query AffiliateAffiliations {
  affiliateAffiliations {
    id
    tier {
      name
      interval
      externalId
    }
    paymentInformation {
      paymentType
    }
    plan {
      id
      name
      organizer{
          profilePicture
          companyName
        }
    }
    affiliate {
      name
      lastName
    }
    expirationDate
    estatus
  }
}`

/* Función para obtener todas las afiliaciones de una organización */
const FETCH_ORGANIZATION_AFFILIATIONS = gql`
query OrganizationAffiliations {
  organizationAffiliations {
    id
    tier {
      name
      interval
      externalId
      amount
    }
    paymentInformation {
      name
      lastName
      email
      paymentType
    }
    billingInformation {
      razonSocialONombreFiscal
      rfc
      usoDelCfdi
      formaDePago
      metodoDePago
      email
      address
	    zipCode
    }
    plan {
      id
      name
      organizer{
          profilePicture
          companyName
        }
    }
    affiliate {
      name
      lastName
    }
    affiliateData
    expirationDate
    estatus
    createdAt
    updatedAt
  }
}`

export { FETCH_USER_AFFILIATIONS, FETCH_ORGANIZATION_AFFILIATIONS }